import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { change, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import {
    getAdminEmpresa,
    getFinanceiroAgencia,
    getFinanceiroEmpresa,
    getFiscalEmbarque,
    getGestorEmpresa,
    getMotoristaEmpresa,
    getOperadorEmpresa,
    getOperadorRemarcacao,
    getPerfisVendedores,
    getVendedorEmpresa,
    getFinanceiroCaixa,
    hasPerfil,
    PERFIL_ADMIN
} from '../security/securityContext';
import Autorizacao from '../security/Autorizacao';

import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';
import DirectionsBusOutlinedIcon from '@material-ui/icons/DirectionsBusOutlined';
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import InsertInvitationOutlinedIcon from '@material-ui/icons/InsertInvitationOutlined';
import CompareArrowsOutlinedIcon from '@material-ui/icons/CompareArrowsOutlined';
import InsertChartOutlinedTwoToneIcon from '@material-ui/icons/InsertChartOutlinedTwoTone';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';
import StoreMallDirectoryOutlinedIcon from '@material-ui/icons/StoreMallDirectoryOutlined';
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import LocalAtmOutlinedIcon from '@material-ui/icons/LocalAtmOutlined';
import AltRouteOutlinedIcon from '@mui/icons-material/AltRouteOutlined';
import SignpostOutlinedIcon from '@mui/icons-material/SignpostOutlined';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DvrIcon from '@mui/icons-material/Dvr'
import iconeTicket from '../img/ticket-perforated-fill.svg';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';


import limparViagens from '../actions/viagem/limpaViagens';
import selecionarReservasRemarcacao from '../actions/remarcacao/selecionarReservasRemarcacao';
import ModalAlterarSenhaUsuario from './usuario/empresa/ModalAlterarSenhaUsuario';

export class PaginaPrincipalEmpresa extends Component {
    render() {
        return (
            <div className="area-home">
                <div className="row sistemas justify-content-md-center mt-5">
                    {this.exibirLinkConfiguracaoBilhete()}
                    {this.exibirLinkUsuario()}
                    {this.exibirLinkVeiculos()}
                    {this.exibirLinkGerenciarDisponibilidadeVeiculo()}
                    {this.exibirLinkGerenciarAgendamentoViagem()}
                    {this.exibirLinkVenderPassagem()}
                    {this.exibirLinkPassagensVendidas()}
                    {this.exibirLinkEncomenda()}
                    {this.props.empresaSelecionada.habilitadoBuscaReservaComBpe ? '' : this.exibirLinkRemarcacao()}

                    {this.exibirLinkRotas()}
                    {this.exibirLinkTrechos()}
                    {this.exibirLinkItinerario()}
                    {this.exibirLinkValores()}
                    {this.props.empresaSelecionada.habilitadoBuscaReservaComBpe ? '' : this.exibirLinkFechamentoCaixa()}
                    {this.exibirLinkAgencia()}
                    {this.props.empresaSelecionada.habilitadoBuscaReservaComBpe ? '' : this.exibirLinkRelatorios()}
                    {this.exibirLinkVexadoBI()}
                    {this.exibirLinkCteos()}
                    {this.exibirConfiguracaoBpe()}
                    {this.exibirAdesaoDePontos()}
                    {this.exibirLinkCentroCusto()}

                </div>
                <ModalAlterarSenhaUsuario />
            </div>
        )
    }

    exibirLinkCentroCusto() {
        return (
            <Autorizacao perfisPermitidos={[
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                PERFIL_ADMIN
            ]} empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/painel-centro-custo">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons">
                                    <ReceiptLongIcon className='css-icon' />
                                </i>
                                <h5 className='nm-longo-resize'>
                                    Centro de Custo
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }


    // eslint-disable-next-line class-methods-use-this
    exibirLinkValores() {
        return (
            <Autorizacao
                perfisPermitidos={[getOperadorEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                ...getPerfisVendedores(this.props.empresaSelecionada.id), PERFIL_ADMIN]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/painel-valores">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"><LocalAtmOutlinedIcon className='css-icon' /></i>
                                <h5>
                                    Valores
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    exibirLinkFechamentoCaixa() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getOperadorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id),
            getGestorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
            ...getPerfisVendedores(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/menu-fechamento-caixa">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"><PointOfSaleIcon className='css-icon' /></i>
                                <h5 className='nm-longo-resize'>
                                    Fechamento de Caixa
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    exibirLinkRelatorios() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getOperadorEmpresa(this.props.empresaSelecionada.id),
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id),
            getFinanceiroCaixa(this.props.empresaSelecionada.id),
            getFinanceiroEmpresa(this.props.empresaSelecionada.id),
            getFiscalEmbarque(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/menu-relatorio">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"><InsertChartOutlinedTwoToneIcon className='css-icon' /></i>
                                <h5>
                                    Relatórios
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    // eslint-disable-next-line class-methods-use-this
    exibirLinkVenderPassagem() {
        return (
            <Autorizacao perfisPermitidos={[...getPerfisVendedores(this.props.empresaSelecionada.id), PERFIL_ADMIN]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/painel-destinos">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons" onClick={() => {
                                    this.props.limparViagens();
                                    this.props.selecionarReservasRemarcacao(null)
                                }}>&#xe8b6;</i>
                                <h5 className='nm-longo-resize'>
                                    Vender Passagem
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    // eslint-disable-next-line class-methods-use-this
    exibirLinkPassagensVendidas() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id),
                ...getPerfisVendedores(this.props.empresaSelecionada.id)
            ]} empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/painel-vendas">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"
                                    onClick={() => this.props.limparViagens()}><ShoppingCartOutlinedIcon className='css-icon' /></i>
                                <h5 className='nm-longo-resize'>
                                    Passagens Vendidas
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    exibirLinkEncomenda() {
        if (this.props.empresaSelecionada.habilitadoEncomenda || hasPerfil(PERFIL_ADMIN)) {
            return (
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getGestorEmpresa(this.props.empresaSelecionada.id),
                    getOperadorEmpresa(this.props.empresaSelecionada.id),
                    getFinanceiroEmpresa(this.props.empresaSelecionada.id),
                    getFinanceiroCaixa(this.props.empresaSelecionada.id),
                    getFinanceiroAgencia(this.props.empresaSelecionada.id),
                    ...getPerfisVendedores(this.props.empresaSelecionada.id)]}
                    empresaSelecionada={this.props.empresaSelecionada}>
                    <div className="col-6 col-sm-6 col-md-3 mt-3">
                        <Link to="/menu-encomendas">
                            <div className="card card-inicial " style={{ height: '90%' }}>
                                <div className="card card-inicial-interno ">
                                    <i className="material-icons custom-icons"
                                        onClick={() => this.props.limparViagens()}><LocalShippingOutlinedIcon className='css-icon' /></i>
                                    <h5 className='nm-longo'>
                                        Encomendas Vexado Express
                                    </h5>
                                </div>
                            </div>
                        </Link>
                    </div>
                </Autorizacao>
            )
        }
    }

    exibirLinkRemarcacao() {
        return (
            <Autorizacao perfisPermitidos={[getAdminEmpresa(this.props.empresaSelecionada.id),
            getOperadorRemarcacao(this.props.empresaSelecionada.id), PERFIL_ADMIN]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/painel-remarcacao">
                        <div className="card card-inicial " style={{ height: '90%' }}>
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"><InsertInvitationOutlinedIcon className='css-icon' /></i>
                                <h5 className='nm-longo'>
                                    Remarcar/Cancelar passagem
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    exibirLinkCteos() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/menu-cteos">
                        <div className="card card-inicial " style={{ height: '90%' }}>
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"><DvrIcon className='css-icon' /></i>
                                <h5 className='nm-longo'>
                                    CT-e OS
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    // eslint-disable-next-line class-methods-use-this
    exibirLinkUsuario() {
        return (
            <Autorizacao perfisPermitidos={[getAdminEmpresa(this.props.empresaSelecionada.id),
            getGestorEmpresa(this.props.empresaSelecionada.id), PERFIL_ADMIN]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/painel-usuarios">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"><PeopleAltOutlinedIcon className='css-icon' /></i>
                                <h5>
                                    Usuários
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    exibirLinkVexadoBI() {
        return (
            <Autorizacao perfisPermitidos={[getAdminEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/painel-vexado-bi">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"><AnalyticsOutlinedIcon className='css-icon' /></i>
                                <h5>
                                    VexBI
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }
    // eslint-disable-next-line class-methods-use-this
    exibirLinkAgencia() {
        return (
            <Autorizacao perfisPermitidos={[getAdminEmpresa(this.props.empresaSelecionada.id),
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getOperadorEmpresa(this.props.empresaSelecionada.id),
                PERFIL_ADMIN]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/painel-agencia">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"><StoreMallDirectoryOutlinedIcon className='css-icon' /></i>
                                <h5>
                                    Agências
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    // eslint-disable-next-line class-methods-use-this
    exibirLinkItinerario() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                ...getPerfisVendedores(this.props.empresaSelecionada.id),
                getMotoristaEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/menu-itinerario">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"><SignpostOutlinedIcon className='css-icon' /></i>
                                <h5>
                                    Itinerários
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    // eslint-disable-next-line class-methods-use-this
    exibirLinkTrechos() {
        return (
            <Autorizacao perfisPermitidos={[getGestorEmpresa(this.props.empresaSelecionada.id),
            getOperadorEmpresa(this.props.empresaSelecionada.id),
            getVendedorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getOperadorRemarcacao(this.props.empresaSelecionada.id),
                PERFIL_ADMIN]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/painel-trechos">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"><CompareArrowsOutlinedIcon className='css-icon' /></i>
                                <h5>
                                    Trechos
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }


    // eslint-disable-next-line class-methods-use-this
    exibirLinkVeiculos() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/painel-veiculos">
                        <div className="card card-inicial">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"><DirectionsBusOutlinedIcon className='css-icon' /></i>
                                <h5>
                                    Veículos
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    exibirLinkGerenciarDisponibilidadeVeiculo() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada} turismo={true}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/painel-calendario-disponibilidade-veiculo">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"><CalendarMonthIcon className='css-icon' /></i>
                                <h5 className='nm-longo-resize-min'>
                                    Calendário Disponibilidade Veículo
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    exibirLinkGerenciarAgendamentoViagem() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada} turismo={true}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/painel-agendamento-viagem">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"><CalendarMonthIcon className='css-icon' /></i>
                                <h5 className='nm-longo-resize-min'>
                                    Agendamento de Viagens
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }


    // eslint-disable-next-line class-methods-use-this
    exibirLinkRotas() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/painel-rotas">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"><AltRouteOutlinedIcon className='css-icon' /></i>
                                <h5>
                                    Rotas
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    montarLinkPainelConfiguracao(empresa) {
        return `/painel-configuracao-bpe?codigoEmpresa=${empresa.id}&habilitadaBPe=${empresa.habilitadoBpe}&pagina=gestao`
    }

    montarLinkPainelConfiguracaoBilhete(empresa) {
        return `/painel-configuracao-bilhete?codigoEmpresa=${empresa.id}&pagina=gestao`
    }

    exibirLinkConfiguracaoBilhete() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to={this.montarLinkPainelConfiguracaoBilhete(this.props.empresaSelecionada)}>
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <img style={{cursor: 'pointer', marginLeft: '10px'}} title='Ticket'  className='material-icons nav-icon'
                                    src={iconeTicket} width={25} height={25} />
                                <h5 className='nm-longo-resize-min' style={{marginTop: '4px'}}>
                                    Configuração Bilhete
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    exibirConfiguracaoBpe() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to={this.montarLinkPainelConfiguracao(this.props.empresaSelecionada)}
                        id="menu-empresa">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons">
                                    <CorporateFareOutlinedIcon className='css-icon' />
                                </i>
                                <h5>
                                    Configurações BPe
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    exibirAdesaoDePontos() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to='/menu-adesao-pontos-empresa' id="menu-empresa">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons">
                                    <CorporateFareOutlinedIcon className='css-icon' />
                                </i>
                                <h5>
                                    Adesão de pontos
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

}

export function mapDispatchToProps(dispatch) {
    return {
        changeFieldValue(field, value) {
            dispatch(change('PaginaInicialForm', field, value))
        },
        limparViagens,
        selecionarReservasRemarcacao,
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        authentication: state.authentication
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(
    reduxForm({
        form: 'PaginaInicialForm',
    })(PaginaPrincipalEmpresa)
))
